import { FormGroup } from "@angular/forms";

export abstract class BaseViewModel {
}